import { render, staticRenderFns } from "./Page_Language.vue?vue&type=template&id=45fd4e20&scoped=true&"
import script from "./Page_Language.vue?vue&type=script&lang=js&"
export * from "./Page_Language.vue?vue&type=script&lang=js&"
import style0 from "./Page_Language.vue?vue&type=style&index=0&id=45fd4e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fd4e20",
  null
  
)

export default component.exports